import "../pages/CheckIn.css";
import { React, useState,useEffect,useRef } from "react";
import DatePicker, { DateObject } from 'react-multi-date-picker';
import {
  Box,
  Chip,
  Stack,
  Paper,
   Button,
   Typography,
} from "@mui/material";

import {  PictureAsPdf, Print } from "@mui/icons-material";
import { apiMain } from "../../App";
// import { Messages } from "../data/Messages";
import { DataGrid ,GridToolbar} from '@mui/x-data-grid';
import { useSnackbar } from "notistack";
// import { useParams } from 'react-router-dom';
import { GetDataPromise } from "../Functions/SendingData";
// import { Loading } from "../Loading";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useReactToPrint } from "react-to-print";
import ExcelIcon from "../images/IconExcel";
const columns = [
    { field: 'id', headerName: 'ID', width: 90   ,  editable: false,},
 // { field: 'Reserv_Id', headerName: 'Id', width: 20 },
  
 {
  field: 'created_at',
  headerName: 'Date',
//  description: 'This column has a value getter and is not sortable.',
  sortable: false,
  type: 'text',
  width: 100,
  editable: false,
  // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
},
  {
    field: 'U_Name',
    headerName: 'User Name',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 250,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
  field: 'Object_Name',
  headerName: 'Type of activity',
//  description: 'This column has a value getter and is not sortable.',
  sortable: false,
  width: 100,
  editable: false,
  // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
},

   {
    field: 'U_Action',
    headerName: 'Action',
    type: 'text',
    width: 110,
    editable: false,
  },
  {
    field: 'Room_Number',
    headerName: 'Room Number',
    type: 'text',
    width: 100,
    editable: false,
  },
  {
    field: 'Type',
    headerName: 'Type',
    type: 'text',
    width: 100,
    editable: false,
  },
];
const paginationModel = { page: 0, pageSize: 5 };
function UserControlReport(props){
  const gridRef = useRef();

  useEffect(() => {
    setFrom_Date(new DateObject());
    let newToDate = new DateObject();
    newToDate.add(10, "day");
    setTo_Date(newToDate);
 }, [])
  // const [value, setValue] = useState('1');
  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };
  //  const [Addflag,setAddflag]=useState(false);

//  const InputRef = useRef(null)

  const getData = async ( ) => {

    let uparams = new URLSearchParams();
    uparams.append("From_Date", From_Date);
    uparams.append("To_Date", To_Date);
    console.log("From_Date", From_Date);
    console.log("To_Date", To_Date);

      let res = await GetDataPromise(`${apiMain}/api/v1/usercontrol/select?${uparams}`, true);

    let parsed = JSON.parse(res);

    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let newData = parsed.data;
        setData(newData)
        console.log(newData)
    }
 
}

  
  // const params = useParams()
   const [data, setData] = useState();
  

  const { enqueueSnackbar } = useSnackbar();
  // const [dialogLoading, setDialogLoading] = useState(false);
  // const [dialogError, setDialogError] = useState({});
  //const [Reserv_Id, setReserv_Id] = useState(0);
 	// const [Id, setId] = useState(0);
    const [From_Date, setFrom_Date] = useState();
    const [To_Date, setTo_Date] = useState();

  //   function handleCloseresturant() {
  //     props.ChangeXpage(0)
  //  }

// const changeFrom_Date =(e)  =>{
//   setFrom_Date(e.target.value)
//   }
  // const changeTo_Date =(e)  =>{
  //   setTo_Date(e.target.value)
  //   }
  //   const changesetId = (event) => {
  //     setId(event.target.value);
  //  };
  //    const handleSubmit = (e) => {
  //       e.preventDefault();
   
  //       // Add your form submission logic here
  //   };



  // 🧾 خروجی به Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, `AgencyReport_${new Date().toISOString()}.xlsx`);
  };

  // 🧾 خروجی به PDF
  const exportToPDF = () => {
    if (!data || data.length === 0) {
      enqueueSnackbar("No data to export", { variant: "warning" });
      return;
    }

    const doc = new jsPDF("p", "pt", "a4");
    doc.setFontSize(16);
    doc.text("Agency Report", 40, 30);
    doc.setFontSize(10);
    doc.text(
      `From: ${From_Date.format("YYYY-MM-DD")}  To: ${To_Date.format(
        "YYYY-MM-DD"
      )}`,
      40,
      45
    );

    const head = [["Name", "Last Name", "Passport", "Room", "Nights", "Account"]];
    const body = data.map((d) => [
      d.Pass_FName || "",
      d.Pass_LName || "",
      d.Pass_No || "",
      d.Room_Number || "",
      d.Night_No || "",
      d.Reserv_Account || "",
    ]);

    autoTable(doc, {
      head,
      body,
      startY: 60,
      theme: "striped",
      headStyles: { fillColor: [22, 160, 133], textColor: 255 },
      styles: { fontSize: 9, cellPadding: 3 },
    });

    doc.save(`AgencyReport_${new Date().toISOString()}.pdf`);
  };

  // 🖨 چاپ مستقیم
  const handlePrint = useReactToPrint({
    content: () => gridRef.current,
    documentTitle: "Agency Report",
  });

    return (
      

      <Box sx={{ p: 2 }}>
      {/* 🔷 فیلترها و کنترل‌ها */}
      <Paper
        elevation={2}
        sx={{
          borderRadius: 2,
          p: 2,
          mb: 3,
          backgroundColor: "#fdfdfd",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap:1,
         

        }}
      >
        {/* <Typography
          variant="h6"
          sx={{ mb: 1, color: "#2c3e50", fontWeight: "bold" }}
        >
          User Control Report Filter
        </Typography> */}
  
        <Stack
  direction="row"
  spacing={1} // ← فاصله کل Stack کمتر شد
  alignItems="center"
  sx={{ mb: 1, overflowX: "auto" }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <label>From:</label>
    <DatePicker
      value={From_Date}
      onChange={setFrom_Date}
      style={{ height: "35px" }}
    />
  </Box>

  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <label>To:</label>
    <DatePicker
      value={To_Date}
      onChange={setTo_Date}
      style={{ height: "35px" }}
    />
  </Box>
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <Chip
    label="Run Report"
    onClick={getData}
    color="primary"
    sx={{
      cursor: "pointer",
      fontWeight: "bold",
      backgroundColor: "#16a085",
      color: "#fff",
    }}
  />
    </Box>
{/* </Stack>



<Stack direction="row" spacing={2}> */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <Button
    variant="contained"
    color="success"
    onClick={exportToExcel}
    sx={{ minWidth: 50, height: 35 }}
  >
     <ExcelIcon />
   
  </Button>
  </Box>
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <Button
    variant="contained"
    color="error"
    onClick={exportToPDF}
    sx={{ minWidth: 50, height: 35 }}
  >
    <PictureAsPdf />
  </Button>
  </Box>
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <Button
    variant="contained"
    sx={{ backgroundColor: "#34495e", minWidth: 50, height: 35 }}
    onClick={handlePrint}
  >
    <Print />
  </Button>
  </Box>
</Stack>

      </Paper>
   
     {/* 🔶 جدول داده‌ها */}
     <Paper
  elevation={4}
  sx={{
    marginTop:0,
    height: 300, // ارتفاع ثابت یا هر مقدار دلخواه
    borderRadius: 3,
  //  overflow: "auto", // اسکرول فعال برای فضای داخلی
    "& .MuiDataGrid-root": {
      border: "none",
      fontFamily: "Roboto, Vazirmatn, sans-serif",
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#16a085",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#16a085 !important",
      color: "#fff !important",
      fontWeight: "bold",
      fontSize: "12px",
      textAlign: "center",
      borderRight: "1px solid rgba(255,255,255,0.2)", // اختیاری برای زیبایی
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "1.4em",
    },
    "& .MuiDataGrid-cell": {
      color: "#2c3e50",
      fontSize: "12px",
      fontWeight: "bold",   //  ← پررنگ شدن داده‌ها
      borderBottom: "1px solid #ecf0f1",
    },
    "& .MuiDataGrid-row:nth-of-type(odd)": {
      backgroundColor: "#f9f9f9",
    },
    "& .MuiDataGrid-row:nth-of-type(even)": {
      backgroundColor: "#ffffff",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#e0f2f1",
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "#f4f6f6",
      borderTop: "2px solid #d5dbdb",
    },
  }}
>
  <DataGrid
    rows={data}
    columns={columns}
    disableColumnMenu={false} // ← منو را فعال کن تا آیکون فیلتر ظاهر شود
    disableColumnSelector
    disableDensitySelector
    hideFooterSelectedRowCount
    filterMode="client" // ← فیلتر سمت کلاینت
    disableColumnFilter={false} // ← مطمئن شو فیلتر غیرفعال نیست
    // slots={{
    //   toolbar: GridToolbar, // ← نوار ابزار شامل فیلتر، جستجو و ...
    // }}
    slotProps={{
      toolbar: {
        showQuickFilter: true, // ← فیلتر سریع بالای جدول
        quickFilterProps: { debounceMs: 500 },
      },
    }}
    hideFooter // ← فوتر پیش‌فرض را مخفی می‌کند
    rowHeight={32} // ارتفاع ردیف‌ها
    headerHeight={36} // ارتفاع هدرها
    pagination={false} // غیرفعال کردن صفحه‌بندی
    autoHeight={false} // غیرفعال کردن ارتفاع خودکار
  />
{/* {  if (data!==undefined) */}
<Typography
  variant="body2"
  sx={{
    p: 1,
    textAlign: "right",
    color: "#2c3e50",
    fontSize: "12px",
  }}
>
Rows: {data ? data.length : 0}
</Typography>


</Paper>
    </Box>

        
    );

}
export default UserControlReport;